module.exports = __webpack_public_path__ + "static/media/rushton-meadows.0730a34a.jpg";